// extracted by mini-css-extract-plugin
module.exports = {"flex":"flex--edRzG","installConfig":"installConfig--tCjQk","btn":"btn--Q7mDV","active":"active--g1eTP","tip":"tip--RaUJz","btnGroup":"btnGroup--vCC_z","failed":"failed--tNCQg"};